import React, { useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";

const MatricularMoodle = () => {

  const [platformUrl] = useState("https://cursos.isepsantafe.net.ar/");
  const [courseid, setCourseid] = useState("");
  const [roleid, setRoleid] = useState("3");

  const [dni, setDni] = useState("");
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [email, setEmail] = useState("");

  const [usuarios, setUsuarios] = useState([]);

  const agregarUsuario = () => {

    if (!dni) {
      Swal.fire("Falta DNI", "Debes ingresar un DNI", "warning");
      return;
    }

    if (usuarios.some(u => u.dni === dni)) {
      Swal.fire("Duplicado", "Ese DNI ya está en la lista", "warning");
      return;
    }

    const nuevo = {
      dni,
      firstname,
      lastname,
      email
    };

    setUsuarios([...usuarios, nuevo]);

    setDni("");
    setFirstname("");
    setLastname("");
    setEmail("");
  };

  const eliminarUsuario = (index) => {
    setUsuarios(usuarios.filter((_, i) => i !== index));
  };

  const enviar = async () => {

    if (!usuarios.length) {
      Swal.fire("Sin usuarios", "Debes agregar al menos uno", "warning");
      return;
    }

    const confirm = await Swal.fire({
      title: "¿Matricular usuarios?",
      text: `Se enviarán ${usuarios.length} alumnos`,
      icon: "question",
      showCancelButton: true
    });

    if (!confirm.isConfirmed) return;

    try {

      const { data } = await axios.post(
        "https://wwwa.isepsantafe.net.ar/expedientes/moodles/matricular",
        {
          users: usuarios,
          platformUrl,
          courseid: Number(courseid),
          roleid: Number(roleid)
        }
      );

      Swal.fire(
        "Matriculación OK",
        `Se matricularon ${data.matriculados} usuarios`,
        "success"
      );

      setUsuarios([]);

    } catch (error) {

      Swal.fire(
        "Error",
        error.response?.data?.error || "Error al matricular",
        "error"
      );
    }
  };

  return (
    <div className="matricular-container">

      <h2>📚 Matricular usuarios en Moodle</h2>

      <div className="config-grid">

        <input
          placeholder="Course ID"
          value={courseid}
          onChange={(e) => setCourseid(e.target.value)}
        />

        <input
          placeholder="Role ID"
          value={roleid}
          onChange={(e) => setRoleid(e.target.value)}
        />

      </div>

      <div className="card">

        <h3>➕ Nuevo usuario</h3>

        <div className="form-grid">

          <input
            placeholder="DNI"
            value={dni}
            onChange={(e) => setDni(e.target.value)}
          />

          <input
            placeholder="Nombre"
            value={firstname}
            onChange={(e) => setFirstname(e.target.value)}
          />

          <input
            placeholder="Apellido"
            value={lastname}
            onChange={(e) => setLastname(e.target.value)}
          />

          <input
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />

        </div>

        <button className="btn-agregar" onClick={agregarUsuario}>
          Agregar usuario
        </button>

      </div>

      <div className="card">

        <h3>👥 Usuarios a matricular ({usuarios.length})</h3>

        <div className="lista">

          {usuarios.map((u, i) => (
            <div className="usuario" key={i}>

              <div>
                <strong>{u.dni}</strong>
                <div>{u.firstname} {u.lastname}</div>
              </div>

              <button
                className="btn-eliminar"
                onClick={() => eliminarUsuario(i)}
              >
                ✖
              </button>

            </div>
          ))}

        </div>

      </div>

      <button className="btn-enviar" onClick={enviar}>
        🚀 Matricular
      </button>

    </div>
  );
};

export default MatricularMoodle;